export function trackPixelEvent(event: string, params?: Record<string, unknown>) {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", event, params);
  }
}

export function trackCheckout() {
  trackPixelEvent("InitiateCheckout", { value: 26.9, currency: "USD", content_name: "Prenatal Training Pro 2026" });
}
